import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-successfully-send-to-approval',
  templateUrl: './successfully-send-to-approval.component.html',
  styleUrls: ['./successfully-send-to-approval.component.scss'],
  standalone: false
})
export class SuccessfullySendToApprovalComponent implements OnInit {
  private route = inject(ActivatedRoute);

  workerId: number;

  constructor() { }

  ngOnInit(): void {
    this.workerId = this.route.snapshot.params.id;
  }
}
